new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_home',
    data: {
        activeIndex: 1,
    },
    methods: {
        toggleShowcase(index) {
            this.activeIndex = index;
        }
    },
    mounted() {
        waitForElementToExist('#faixa-cupom').then(element => {
            const faixCupom = document.querySelector('.faixa-cupom');

            if (faixCupom) {
                const formButton = document.querySelector('.faixa-cupom-form button');
                const spanElement = document.getElementById("valorParaCopiar");

                if (spanElement && formButton) {
                    let newValue = spanElement.textContent.replace(/^\/\//, '');

                    const icon = formButton.querySelector('i');
                    const originalText = formButton.textContent;

                    formButton.addEventListener("click", (e) => {
                        e.preventDefault();

                        navigator.clipboard.writeText(newValue).then(() => {

                            // altera texto mantendo o ícone
                            if (icon) {
                                formButton.innerHTML = 'Copiado!';
                            } else {
                                formButton.textContent = 'Copiado!';
                            }

                            // volta ao original após 2s
                            setTimeout(() => {
                                if (icon) {
                                    formButton.innerHTML = icon.outerHTML + ' ' + originalText.trim();
                                } else {
                                    formButton.textContent = originalText;
                                }
                            }, 2000);

                        }).catch(err => {
                            console.error('Erro ao copiar: ', err);
                        });
                    });
                }
            }
        });
    },
});

//sliders
$(document).ready(function () {


    var bannerHomeFull = $('.banner-home');
    var optionsBannerHome = {
        swipeToSlide: true, 
        touchThreshold: 100,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 4000,
        dots: true,
        infinite: false,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 2000,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function (event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);

    waitForElementToExist('.rotation-vitrine-first').then(element => {
        $('#carrousel-product-list').slick({
            arrows: true,
            swipeToSlide: true,
            touchThreshold: 100,
            prevArrow: $(".rotation-vitrine-first .arrows-content-mobile .arrows-mobile .count-prev"),
            nextArrow: $(".rotation-vitrine-first .arrows-content-mobile .arrows-mobile .count-next"),
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 300,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToScroll: 3,
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 1275,
                    settings: {
                        prevArrow: $(".rotation-vitrine-first .count .count-prev"),
                        nextArrow: $(".rotation-vitrine-first .count .count-next"),
                        slidesToScroll: 4,
                        slidesToShow: 4,
                    }
                }
            ]
        });

        $('#carrousel-product-list2').slick({
            arrows: true,
            swipeToSlide: true,
            touchThreshold: 100,
            prevArrow: $(".rotation-vitrine-first .arrows-content-mobile .arrows-mobile .count-prev2"),
            nextArrow: $(".rotation-vitrine-first .arrows-content-mobile .arrows-mobile .count-next2"),
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 300,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToScroll: 3,
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 1275,
                    settings: {
                        prevArrow: $(".rotation-vitrine-first .count .count-prev2"),
                        nextArrow: $(".rotation-vitrine-first .count .count-next2"),
                        slidesToScroll: 4,
                        slidesToShow: 4,
                    }
                }
            ]
        });

        if (element) {
            let rotationNames = element.querySelectorAll('.vitrines-select .vitrines-select-name');
            let initVitrine = element.querySelectorAll('.vitrines-products .vitrines-products-item');
            initVitrine = Array.from(initVitrine);

            if (rotationNames.length && initVitrine.length) {
                initVitrine[0].classList.add('active');
                rotationNames[0].classList.add('active');

                function activeTab(index) {
                    initVitrine.forEach((content) => {
                        content.classList.remove('active');
                    });
                    rotationNames.forEach((content) => {
                        content.classList.remove('active');
                    });
                    initVitrine[index].classList.add('active');
                    rotationNames[index].classList.add('active');

                    // Atualizar classe no contêiner .count (count-1, count-2)
                    $('.rotation-vitrine-first .count').attr('class', function (i, c) {
                        return c.replace(/(^|\s)count-\S+/g, '');
                    }).addClass(`count count-${index + 1}`);

                    // Atualizar classe no contêiner .arrows-mobile (count-1, count-2)
                    $('.rotation-vitrine-first .arrows-content-mobile .arrows-mobile').attr('class', function (i, c) {
                        return c.replace(/(^|\s)count-\S+/g, '');
                    }).addClass(`arrows-mobile count-${index + 1}`);

                    // Atualizar links "VER TUDO" com base no data-link da aba ativa
                    const link = rotationNames[index].getAttribute('data-link');
                    const desktopLink = $('.rotation-vitrine-first .count .link-general');
                    const mobileLink = $('.rotation-vitrine-first .arrows-content-mobile .link-general');

                    if (desktopLink.length && mobileLink.length) {
                        if (link && link !== '' && link !== '#') {
                            desktopLink.attr('href', link).show();
                            mobileLink.attr('href', link).show();
                        } else {
                            desktopLink.hide();
                            mobileLink.hide();
                        }
                    }

                    // Refresh slick carousels
                    const carouselIds = [
                        '#carrousel-product-list',
                        '#carrousel-product-list2',
                    ];
                    carouselIds.forEach(id => {
                        const $carousel = $(id);
                        if ($carousel.hasClass('slick-initialized')) {
                            $carousel.slick('refresh');
                        }
                    });
                }

                rotationNames.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', (e) => {
                        e.preventDefault();
                        activeTab(index);
                    }, { passive: true });
                });

                // Initial update for the first active tab
                activeTab(0);
            }
        }

        $('#carrousel-product-list, #carrousel-product-list2').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                    }, 200);
                }
            });
        });
    });

    waitForElementToExist('.faixa-beneficios').then(element => {
        $('.faixa-beneficios-list').slick({
            arrows: false,
            dots: false,
            autoplay: true,
            autoplaySpeed: 2500,
            infinite: true,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 400,
            responsive: [
                {
                    breakpoint: 991,
                    settings: 'unslick'
                }
            ]
        });
    });

    waitForElementToExist('.nav-category').then(element => {
        const navCatCarousels = ['#nav-cat-carousel-1', '#nav-cat-carousel-2', '#nav-cat-carousel-3'];
        const navCatSlickOptions = {
            arrows: false,
            swipeToSlide: true,
            touchThreshold: 100,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 300,
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 1,
                    }
                }
            ]
        };

        const prevBtns = element ? element.querySelectorAll('.nav-cat-prev') : [];
        const nextBtns = element ? element.querySelectorAll('.nav-cat-next') : [];
        const verTudoLinks = element ? element.querySelectorAll('.nav-cat-ver-tudo') : [];
        let activeTabIndex = 0;

        function updateNavCatArrows(slick, currentSlide) {
            if (!prevBtns.length || !nextBtns.length) return;
            const slideCount = slick.slideCount;
            const slidesToShow = slick.options.slidesToShow || 1;
            prevBtns.forEach(btn => btn.classList.toggle('slick-disabled', currentSlide === 0));
            nextBtns.forEach(btn => btn.classList.toggle('slick-disabled', currentSlide >= slideCount - slidesToShow));
        }

        navCatCarousels.forEach((id, i) => {
            const $el = $(id);
            if ($el.length) {
                $el.on('init', function (event, slick) {
                    if (i === 0) updateNavCatArrows(slick, 0);
                });
                $el.slick(navCatSlickOptions);
                $el.on('afterChange', function (event, slick, currentSlide) {
                    if (i === activeTabIndex) updateNavCatArrows(slick, currentSlide);
                });
            }
        });

        if (element) {
            let rotationNames = element.querySelectorAll('.vitrines-select .vitrines-select-name');
            let initVitrine = element.querySelectorAll('.vitrines-products .vitrines-products-item');
            initVitrine = Array.from(initVitrine);

            if (rotationNames.length && initVitrine.length) {
                function activeNavCatTab(index) {
                    activeTabIndex = index;
                    initVitrine.forEach(content => content.classList.remove('active'));
                    rotationNames.forEach(content => content.classList.remove('active'));
                    initVitrine[index].classList.add('active');
                    rotationNames[index].classList.add('active');

                    // Atualiza o link "Ver Tudo" conforme a aba ativa
                    const link = rotationNames[index].getAttribute('data-link');
                    verTudoLinks.forEach(a => {
                        a.href = link || '#';
                        a.style.visibility = link ? 'visible' : 'hidden';
                    });

                    const $carousel = $(navCatCarousels[index]);
                    if ($carousel.hasClass('slick-initialized')) {
                        $carousel.slick('refresh');
                        const slickInstance = $carousel[0].slick;
                        updateNavCatArrows(slickInstance, slickInstance.currentSlide);
                    }
                }

                rotationNames.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', e => {
                        e.preventDefault();
                        activeNavCatTab(index);
                    }, { passive: true });
                });

                prevBtns.forEach(btn => {
                    btn.addEventListener('click', () => {
                        const $carousel = $(navCatCarousels[activeTabIndex]);
                        if ($carousel.hasClass('slick-initialized')) {
                            $carousel.slick('slickPrev');
                        }
                    });
                });

                nextBtns.forEach(btn => {
                    btn.addEventListener('click', () => {
                        const $carousel = $(navCatCarousels[activeTabIndex]);
                        if ($carousel.hasClass('slick-initialized')) {
                            $carousel.slick('slickNext');
                        }
                    });
                });

                activeNavCatTab(0);
            }
        }
    });

    waitForElementToExist('.first-vitrine').then(element => {
        const firstCarrousel = element.querySelector('#product_list');
        if(firstCarrousel) {
            // Detectar se é mobile ou desktop para usar as arrows corretas
            const isMobile = window.innerWidth < 1024;
            const prevArrow = isMobile ? $('.first-vitrine > .arrows-content .arrows-mobile .prev') : $('.first-vitrine .group-text .arrows-content .arrows .prev');
            const nextArrow = isMobile ? $('.first-vitrine > .arrows-content .arrows-mobile .next') : $('.first-vitrine .group-text .arrows-content .arrows .next');

            $('#product_list').slick({
                swipeToSlide: true,
                touchThreshold: 100,
                arrows: true,
                prevArrow: prevArrow,
                nextArrow: nextArrow,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 300,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4,
                            prevArrow: $('.first-vitrine .group-text .arrows-content .arrows .prev'),
                            nextArrow: $('.first-vitrine .group-text .arrows-content .arrows .next'),
                        }
                    }
                ]
            });

            // Atualizar arrows ao redimensionar
            $(window).on('resize', function() {
                const wasResized = (window.innerWidth >= 1024) !== !isMobile;
                if (wasResized && $('#product_list').hasClass('slick-initialized')) {
                    $('#product_list').slick('refresh');
                }
            });

            $('#product_list').on('afterChange', function(event, slick, currentSlide, nextSlide){
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function(element) {
                        setTimeout(function(){
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.cupom-section').then(element => {

        // Copiar cupom
        const copyBtn = document.getElementById('cupom-copy-btn');
        const cupomCode = document.getElementById('cupom-code-text');

        if (copyBtn && cupomCode) {
            copyBtn.addEventListener('click', function() {
                const code = cupomCode.textContent;

                // Copiar para clipboard
                navigator.clipboard.writeText(code).then(() => {
                    // Feedback visual
                    copyBtn.classList.add('copied');
                    const originalText = copyBtn.textContent;
                    copyBtn.textContent = 'COPIADO!';

                    setTimeout(() => {
                        copyBtn.classList.remove('copied');
                        copyBtn.textContent = originalText;
                    }, 2000);
                }).catch(err => {
                    console.error('Erro ao copiar: ', err);

                    // Fallback para navegadores antigos
                    const textArea = document.createElement('textarea');
                    textArea.value = code;
                    textArea.style.position = 'fixed';
                    textArea.style.left = '-999999px';
                    document.body.appendChild(textArea);
                    textArea.select();

                    try {
                        document.execCommand('copy');
                        copyBtn.classList.add('copied');
                        const originalText = copyBtn.textContent;
                        copyBtn.textContent = 'COPIADO!';

                        setTimeout(() => {
                            copyBtn.classList.remove('copied');
                            copyBtn.textContent = originalText;
                        }, 2000);
                    } catch (err) {
                        console.error('Fallback: Erro ao copiar', err);
                    }

                    document.body.removeChild(textArea);
                });
            });
        }

        // Carrossel de imagens no mobile
        const slider = $('.cupom-images-slider');
        if (slider.length) {
            // Destruir slick se já existir
            if (slider.hasClass('slick-initialized')) {
                slider.slick('unslick');
            }

            // Garantir que as imagens estejam visíveis antes de inicializar
            slider.find('img').css('opacity', '1');

            // Inicializar slick apenas no mobile
            function initSlider() {
                if (window.innerWidth < 992) {
                    slider.slick({
                        dots: false,
                        arrows: false,
                        infinite: true,
                        speed: 300,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        adaptiveHeight: false,
                        swipeToSlide: true,
                        touchThreshold: 100,
                        lazyLoad: 'ondemand',
                    });

                    // Forçar refresh após inicializar
                    setTimeout(() => {
                        if (slider.hasClass('slick-initialized')) {
                            slider.slick('setPosition');
                        }
                    }, 100);
                } else {
                    if (slider.hasClass('slick-initialized')) {
                        slider.slick('unslick');
                    }
                }
            }

            initSlider();

            // Reinicializar ao redimensionar
            let resizeTimer;
            $(window).on('resize', function() {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(function() {
                    initSlider();
                }, 250);
            });
        }
    });
    
});